import { makeAutoObservable } from "mobx"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import type {
  IApproverGroupDto,
  IApproverGroupMembersInputDto,
  ICreateOrUpdateApproverGroupDto,
  IPagedApproverGroupRequestDto,
} from "@services/approverGroup/approverGroupDto"
import approverGroupService from "@services/approverGroup/approverGroupService"

/**
 * R17 — MobX state cho màn hình quản lý nhóm người duyệt. Gọi service, giữ list/detail
 * và cờ loading; không chứa JSX.
 */
class ApproverGroupStore {
  tableData: PagedResultDto<IApproverGroupDto> = { items: [], totalCount: 0 }
  detailData: IApproverGroupDto | null = null
  isLoading = false

  constructor() {
    makeAutoObservable(this)
  }

  async getAll(params: IPagedApproverGroupRequestDto) {
    this.isLoading = true
    try {
      this.tableData = await approverGroupService.getAll(params)
    } finally {
      this.isLoading = false
    }
  }

  async get(id: number) {
    this.isLoading = true
    try {
      this.detailData = await approverGroupService.get(id)
      return this.detailData
    } finally {
      this.isLoading = false
    }
  }

  async create(body: ICreateOrUpdateApproverGroupDto) {
    this.isLoading = true
    try {
      return await approverGroupService.create(body)
    } finally {
      this.isLoading = false
    }
  }

  async update(body: ICreateOrUpdateApproverGroupDto) {
    this.isLoading = true
    try {
      return await approverGroupService.update(body)
    } finally {
      this.isLoading = false
    }
  }

  async deactivate(id: number) {
    this.isLoading = true
    try {
      await approverGroupService.deactivate(id)
    } finally {
      this.isLoading = false
    }
  }

  async addMembers(body: IApproverGroupMembersInputDto) {
    this.isLoading = true
    try {
      return await approverGroupService.addMembers(body)
    } finally {
      this.isLoading = false
    }
  }

  async removeMembers(body: IApproverGroupMembersInputDto) {
    this.isLoading = true
    try {
      return await approverGroupService.removeMembers(body)
    } finally {
      this.isLoading = false
    }
  }

  async delete(id: number) {
    this.isLoading = true
    try {
      await approverGroupService.delete(id)
    } finally {
      this.isLoading = false
    }
  }

  initDetail() {
    this.detailData = null
  }
}

export default ApproverGroupStore
